module.exports = __webpack_public_path__ + "static/media/Miscellaneous_m_mr.57ff89d8.jpg";